<template>
  <b-container fluid class="login-page-container">
    <div class="login-card-wrapper">
      <b-card class="login-card" no-body>
        <div class="login-card-header">
          <div class="login-logo-wrapper" v-if="isUp()">
            <img src="../assets/candesic-2.png" alt="Candesic Logo" class="login-logo" />
            <span class="login-title">Portal</span>
          </div>
        </div>
        
        <div class="login-card-body">
          <div v-if="isUp()" class="w-100">
            <AzureAuth :mobileView="mobileView" />
          </div>
          <div v-else class="service-down-msg">
            <b-icon icon="exclamation-triangle" variant="danger" class="mb-3" font-scale="3"></b-icon>
            <h4 class="text-danger font-weight-bold">Service Unavailable</h4>
            <p class="text-muted">{{ appMessage || 'Service is not available right now. Please try again later.' }}</p>
          </div>

          <div v-if="errorMessage" class="login-error-alert mt-4">
            <b-icon icon="exclamation-circle-fill" class="mr-2"></b-icon>
            {{ errorMessage.toLowerCase() }}
          </div>
        </div>
        
        <div class="login-card-footer">
          <span>Version {{ appVersion }}</span>
        </div>
      </b-card>
    </div>
  </b-container>
</template>

<script>
import AzureAuth from './Azure.vue'

export default {
  name: 'AboutComponent',
  props: ['errorMessage', 'mobileView'],
  components: {
    AzureAuth
  },
  data() {
    return {
      status: this?.$store?.getters?.appStatus
    }
  },
  methods: {
    isUp() {
      return this.status === 'up'
    }
  },
  computed: {
    appName() {
      return this?.$store?.getters?.appName ?? 'default'
    },
    appVersion() {
      return this?.$store?.getters?.appVersion ?? '0.0.0'
    },
    appEnv() {
      return this?.$store?.getters?.appEnv ?? 'production'
    },
    appMessage() {
      return this?.$store?.getters?.appMessage ?? ''
    }
  }
}
</script>

<style scoped>
.login-page-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 120px) !important;
  padding: 2rem 1rem !important;
}

.login-card-wrapper {
  width: 100%;
  max-width: 440px;
}

.login-card {
  background: rgba(255, 255, 255, 0.85) !important;
  backdrop-filter: blur(20px) !important;
  -webkit-backdrop-filter: blur(20px) !important;
  border: 1px solid rgba(255, 255, 255, 0.4) !important;
  border-radius: 20px !important;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1) !important;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.login-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.15) !important;
}

.login-card-header {
  padding: 2.5rem 2rem 1.5rem 2rem;
  text-align: center !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.login-logo-wrapper {
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 6px !important;
}

.login-logo {
  height: 48px !important;
  margin: 0 !important;
  display: inline-block !important;
  filter: drop-shadow(0 4px 6px rgba(0, 0, 0, 0.03)) !important;
}

.login-title {
  font-family: 'CANDESIC-FONT', Arial, Helvetica, sans-serif !important;
  font-size: 1.4rem !important;
  font-weight: 800 !important;
  color: rgb(0, 114, 188) !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  line-height: 1 !important;
}

.login-card-body {
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.service-down-msg {
  text-align: center;
  padding: 1rem 0;
}

.login-error-alert {
  background-color: rgba(239, 68, 68, 0.08) !important;
  border: 1px solid rgba(239, 68, 68, 0.2) !important;
  color: #dc2626 !important;
  padding: 0.75rem 1rem !important;
  border-radius: 10px !important;
  font-size: 0.85rem !important;
  font-weight: 500;
  width: 100%;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 4px rgba(220, 38, 38, 0.02);
}

.login-card-footer {
  padding: 1.25rem 2rem;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.02);
  border-top: 1px solid rgba(0, 0, 0, 0.04);
  font-size: 0.75rem !important;
  color: #94a3b8 !important;
  font-weight: 500;
}

/* Custom styling for Azure button inside card */
.login-card-body ::v-deep .btn-premium-auth {
  width: 100% !important;
  padding: 0.8rem 1.5rem !important;
  font-size: 0.95rem !important;
  border-radius: 12px !important;
  background-color: #0084da !important;
  border-color: #0076c5 !important;
  color: #ffffff !important;
  box-shadow: 0 4px 14px rgba(0, 132, 218, 0.3) !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-card-body ::v-deep .btn-premium-auth:hover {
  background-color: #0076c5 !important;
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(0, 132, 218, 0.4) !important;
}

.login-card-body ::v-deep .btn-premium-auth:active {
  transform: translateY(0);
}

.login-card-body ::v-deep .ms-logo {
  width: 20px;
  height: 20px;
  margin-right: 12px;
}
</style>
